import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates'

import './DatepickerModal.scss'

import formats from '../../configuration/formats'

import Modal from '../Modal/Modal'

import calendarIcon from '../../assets/images/calendar-icon.svg'

const DatePickerModal = ({
  handleDateChange,
  selectedDate,
  isDayHighlighted,
  disabled,
  className,
  targetCalDate,
}) => {
  const selectedMoment = selectedDate ? moment(selectedDate) : null

  const inputRef = useRef(null)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const onModalClose = () => {
    setIsModalOpen(false)
  }

  const onFocus = () => {
    inputRef.current.blur()
    setIsModalOpen(true)
  }

  const handleDatePickerChange = momentObj => {
    handleDateChange(momentObj)
    setIsModalOpen(false)
  }

  const handleClick = () => {
    if (!inputRef.current.disabled) {
      setIsModalOpen(true)
    }
  }

  return (
    <div
      className={`${
        disabled && 'disabled'
      } date-picker border-bottom border-off-white flex flex-space-between`}
    >
      <input
        type="text"
        disabled={disabled}
        ref={inputRef}
        onFocus={onFocus}
        className="date-picker-input"
        placeholder="Sail Date"
        defaultValue={
          selectedMoment
            ? selectedMoment.format(formats.datePickerDisplayDate)
            : ''
        }
      />
      <img src={calendarIcon} onClick={handleClick} alt="calendar" />

      <Modal
        onRequestClose={onModalClose}
        isOpen={isModalOpen}
        className={`datepicker-modal ${className}`}
        overlayClassName="datepicker-modal-overlay"
      >
        <SingleDatePicker
          onDateChange={handleDatePickerChange}
          focused
          onFocusChange={() => setIsModalOpen(false)}
          date={selectedMoment}
          isDayHighlighted={isDayHighlighted}
          isDayBlocked={d => !isDayHighlighted(d)}
          placeholder="Sail Date"
          numberOfMonths={window.innerWidth >= 768 ? 2 : 1}
          isOutsideRange={day =>
            day.isBefore(moment('2020-03-13', 'YYYY-MM-DD'))
          }
          displayFormat={formats.datePickerDisplayDate}
          initialVisibleMonth={() => targetCalDate || null}
        />
      </Modal>
    </div>
  )
}

DatePickerModal.defaultProps = {
  disabled: false,
  className: null,
  targetCalDate: null,
}

DatePickerModal.propTypes = {
  handleDateChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  isDayHighlighted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  targetCalDate: PropTypes.shape({}),
}

export default DatePickerModal
